import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';

const Wrapper = ({title, vehicle, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}/>
      <Notice
        display={vehicle && vehicle.archived}
        message={[
          'This vehicle has been archived and is therefore no longer available.',
          vehicle?.deleted_at ? 'You won\'t be able to modify it unless it is restored.' : 'A relation was archived therefore you can not restore it directly'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['vehicle']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Vehicles', link: routes.vehicles.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: routes.archive.index},
  {title: 'Vehicles', link: reverse(routes.archive.index, {tab: 'vehicles'})}
];

export default Wrapper;
